import { Http } from '@/services/http'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'
import { Injectable } from '@tanbo/vue-di-plugin'
import { TableMemoryPagination } from '@/services/table-memory-pagination'
import { ParamsClean } from '@/common/decorators/params-clean'
export interface QueryParams {
  /** 结束时间 */
  end_time?: string
  /** 计算机|登记用户名|ip地址 */
  key_word?: string
  /** 每页多少条 */
  limit: number
  /** 第几页 */
  page: number
  /** 终端分组id */
  group_id?: number
  /** 开始时间 */
  start_time?: string
  /** 排序字段 */
  sort?: string
  /** 顺序 */
  asc?: boolean
  soft_id?: number
  soft_name?: string
  useMemory: boolean
}

export interface ClientInfo {
  /** 计算机名 */
  computer_name: string
  /** 登记用户名 */
  user_mark: string
  /** 分组名 */
  group_name: string
  /** 外网IP */
  client_ip: string
  /** 内网IP */
  system_ip: string
  /** 已使用软件 */
  soft_count: number
  /** 日均使用次数 */
  use_soft_count: number
  /** 日均使用时长（分钟） */
  duration: number
  /** 终端id */
  device_id: string
  /** 软件版本 */
  soft_version: string
  /** 安装时间 */
  install_time: string
  /** 最后活跃时间（展示用字符串或时间戳） */
  last_active_time?: string | number
  system_type?: number
  login_status?: number
  /** 唯一标识某一条软件安装记录的键 */
  soft_hash_key?: string
}

/** soft-uninstall 单条目标：全选分组卸载时仅传 soft_hash_key */
export interface UninstallListItem {
  device_id?: string
  soft_hash_key: string
}

export interface SoftwareUninstallParams {
  /** 卸载类型,0-提醒卸载，1-启动卸载 */
  uninstall_type: number
  /** 0-指定终端，1-全部（分组条件下） */
  execute_type?: number
  /** 卸载目标列表 */
  uninstall_list: UninstallListItem[]
  soft_name?: string
}

@Injectable()
export class InstalledDetailService extends TableMemoryPagination<QueryParams, ClientInfo> {
  constructor (private http: Http) {
    super()
  }

  isEqual (el1: ClientInfo, el2: ClientInfo) {
    return el1.device_id === el2.device_id
  }

  @ParamsClean()
  @InvokeThrottle()

  getListByServer (params: Partial<QueryParams>) {
    return this.http.post<{
      total: number
      list: Record<string, unknown>[]
    }>('/softmgr/userecord/soft-terminal-list', params).then((res) => ({
      total: res.total ?? 0,
      list: (res.list || []).map((raw) => this.mapSoftTerminalRow(raw)),
    }))
  }

  private mapSoftTerminalRow (raw: Record<string, unknown>): ClientInfo {
    const avgUse = (raw.avg_use_count ?? raw.use_soft_count) as number | undefined
    const avgDur = (raw.avg_duration ?? raw.duration) as number | undefined
    const lastTs = raw.last_active_time
    const installRaw = raw.install_time
    return {
      computer_name: String(raw.computer_name ?? ''),
      user_mark: String(raw.user_mark ?? ''),
      group_name: String(raw.group_name ?? ''),
      client_ip: String(raw.client_ip ?? ''),
      system_ip: String(raw.system_ip ?? ''),
      soft_count: Number(raw.soft_count ?? 0),
      use_soft_count: Number(avgUse ?? 0),
      duration: Number(avgDur ?? 0),
      device_id: String(raw.device_id ?? ''),
      soft_version: String(raw.soft_version ?? ''),
      install_time: installRaw != null ? String(installRaw) : '',
      last_active_time: lastTs as string | number | undefined,
      system_type: raw.system_type != null ? Number(raw.system_type) : undefined,
      login_status: raw.login_status != null ? Number(raw.login_status) : undefined,
      soft_hash_key: raw.soft_hash_key != null ? String(raw.soft_hash_key) : undefined,
    }
  }

  download (type: 0|1, options: QueryParams, moduleName: string) {
    const params = Object.assign({}, options, {
      file_type: type,
      page: 0, // 不分页
      limit: 0
    })
    return this.http.downloadWithBlob('/softmgr/authentic-soft/list/export', params, moduleName)
  }

  uninstallSoftware (params: SoftwareUninstallParams) {
    return this.http.post('/terminal-order/soft-uninstall', params)
  }
}
